<template>
  <div class="intro-section mb-5">
    <v-container fluid>
      <h2>AFTALETIDSIMPORT</h2>
    </v-container>
    <v-container fluid class="py-5 px-lg-10">
      <v-row justify="space-between" class="my-0">
        <v-col cols="12" md="2" class="py-0">
          <v-text-field label="Visitations nr." v-model="visitNumber" @keyup.enter="setFilterParams"/>
        </v-col>
        <v-col cols="7" md="2" class="py-0 pr-0">
          <v-text-field label="CPR-Nummer" v-model="cprNumber" maxlength="6" @keyup.enter="setFilterParams"/>
        </v-col>
        <v-col cols="5" md="2" class="py-0">
          <v-text-field v-model="cprNumberAdd" maxlength="4" @keyup.enter="setFilterParams"/>
        </v-col>
        <v-col class="py-0">
          <v-menu ref="menuFrom" v-model="menuFrom" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field :value="formattedDateFrom" class="datepicker-input" append-icon="mdi-calendar" @click:append="menuFrom = true" label="Dato" readonly v-on="on"/>
            </template>
            <v-date-picker v-model="dateFrom" no-title @change="menuFrom = false" color="primary lighten-0"/>
          </v-menu>
        </v-col>
        <v-col cols="auto" class="py-0 px-0" align-self="center">
          <v-icon size="15">icon-minus</v-icon>
        </v-col>
        <v-col class="py-0">
          <v-menu ref="menuTo" v-model="menuTo" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field :value="formattedDateTo" class="datepicker-input" append-icon="mdi-calendar" @click:append="menuTo = true" readonly v-on="on"/>
            </template>
            <v-date-picker v-model="dateTo" no-title @change="menuTo = false" color="primary lighten-0"/>
          </v-menu>
        </v-col>
      </v-row>
      <v-row class="my-0">
        <v-col cols="12" md="4" class="py-0">
          <v-select v-model="status" :items="statusesList" :disabled="statusesList.length <= 1" item-text="item2" item-value="item1" label="Status"/>
        </v-col>
        <v-col cols="12" md="4" class="py-0 pr-0">
          <v-text-field label="Ekstern kode" v-model="externalAppointmentId" @keyup.enter="setFilterParams"/>
        </v-col>
      </v-row>
    </v-container>
    <div class="intro-section__bottom-box">
      <div class="d-flex justify-end flex-wrap align-center pa-5">
        <v-btn depressed class="my-1" color="primary" :disabled="tableLoading" outlined @click="clearFilters">
          <v-icon left size="25" class="mr-4">icon-close</v-icon>
          Reset filtre
        </v-btn>
        <v-btn depressed class="ml-2 my-1" color="primary" :disabled="tableLoading" @click="setFilterParams">
          <v-icon left size="22" class="mr-4">icon-search</v-icon>
          Søg
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
  import methods from '@/utils/methods';

  export default {
    name: 'ImportFilters',

    data: function () {
      return {
        visitNumber: '',
        cprNumber: '',
        cprNumberAdd: '',
        menuFrom: false,
        dateFrom: null,
        menuTo: false,
        dateTo: null,
        externalAppointmentId: '',
        status: '',
      };
    },

    mounted: async function() {
      this.setFilterParams();
    },

    computed: {
      tableLoading: function () {
        return this.$store.state.imports.tableLoading;
      },
      statusesList: function () {
        return this.$store.state.imports.statusesList;
      },
      formattedDateFrom: function () {
        if (this.dateFrom) {
          return methods.formatDate(this.dateFrom);
        } else {
          return 'Fra';
        }
      },
      formattedDateTo: function () {
        if (this.dateTo) {
          return methods.formatDate(this.dateTo);
        } else {
          return 'Til';
        }
      },
    },

    methods: {
      clearFilters: function () {
        this.visitNumber = '';
        this.cprNumber = '';
        this.cprNumberAdd = '';
        this.dateFrom = null;
        this.dateTo = null;
        this.externalAppointmentId = '';
        this.status = '';
        this.setFilterParams();
      },
      filterParams: function () {
        let params = {};
        this.dateFrom && (params.From = new Date(this.dateFrom).toISOString());
        this.dateTo && (params.To = new Date(this.dateTo).toISOString());
        this.visitNumber && (params.VisitId = parseInt(this.visitNumber));
        this.externalAppointmentId && (params.externalAppointmentId = this.externalAppointmentId);
        (typeof(this.status) === 'number') && (params.status = this.status);
        if (this.cprNumber || this.cprNumberAdd) {
          if (this.cprNumberAdd) {
            params.Cpr = `${this.cprNumber}-${this.cprNumberAdd}`;
          } else {
            params.Cpr = this.cprNumber;
          }
        }
        return params;
      },
      setFilterParams: function () {
        if (!this.tableLoading) {
          this.$store.commit('imports/updateFilterParams', this.filterParams());
        }
      },
    },
  };
</script>
